export const municipality_data_all = {
  'selected_municipalities_data': {
    "type": "FeatureCollection",
    "crs": {
      "type": "name",
      "properties": {
        "name": "urn:ogc:def:crs:OGC:1.3:CRS84"
      }
    },
    "features": [{
        "type": "Feature",
        "properties": {
          "id": null,
          "F_ID": 104,
          "N_ID": "bhaktapur-bhaktapur",
          "NAME": "Bhaktapur",
          "LEVEL": "Nagarpalika",
          "DISTRICT": "Bhaktapur"
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [85.444591761422274, 27.6644082441845],
              [85.443777293226191, 27.663588260910537],
              [85.440519420441831, 27.666048210732423],
              [85.428302397500531, 27.66522822745846],
              [85.420157715539659, 27.666458202369405],
              [85.410384097186608, 27.671788093650157],
              [85.402239415225736, 27.673838051835062],
              [85.405497288010082, 27.677117984930913],
              [85.407940692598345, 27.677527976567895],
              [85.410384097186608, 27.677117984930913],
              [85.414456438167051, 27.6795779347528],
              [85.419343247343576, 27.677527976567895],
              [85.427487929304448, 27.678757951478836],
              [85.437261547657485, 27.6795779347528],
              [85.440519420441831, 27.688187759129402],
              [85.450293038794882, 27.691057700588267],
              [85.448664102402716, 27.686957784218457],
              [85.448664102402716, 27.682037884574687],
              [85.447035166010536, 27.676707993293931],
              [85.451107506990965, 27.675478018382989],
              [85.447849634206619, 27.66850816055431],
              [85.444591761422274, 27.666458202369405],
              [85.444591761422274, 27.6644082441845]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "id": null,
          "F_ID": 105,
          "N_ID": "madhyapur -thimi-bhaktap",
          "NAME": "Madhyapur Thimi",
          "LEVEL": "Nagarpalika",
          "DISTRICT": "Bhaktapur"
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [85.363144941813559, 27.668918152191292],
              [85.35418579165659, 27.667688177280347],
              [85.358258132637033, 27.675888010019968],
              [85.35744366444095, 27.678347959841854],
              [85.359072600833116, 27.682447876211665],
              [85.362330473617462, 27.681627892937705],
              [85.36966068738225, 27.688187759129402],
              [85.372104091970513, 27.689007742403362],
              [85.373733028362693, 27.692287675499212],
              [85.376176432950956, 27.690647708951289],
              [85.377805369343122, 27.690647708951289],
              [85.377805369343122, 27.694337633684118],
              [85.380248773931385, 27.693107658773176],
              [85.38350664671573, 27.693927642047136],
              [85.386764519500076, 27.692287675499212],
              [85.386764519500076, 27.695977600232041],
              [85.389207924088339, 27.696797583506005],
              [85.391651328676602, 27.697207575142986],
              [85.390836860480519, 27.700897499875815],
              [85.391651328676602, 27.702127474786757],
              [85.394909201460962, 27.702537466423738],
              [85.397352606049211, 27.700897499875815],
              [85.398167074245308, 27.701717483149778],
              [85.401424947029653, 27.698027558416946],
              [85.403053883421833, 27.684497834396574],
              [85.407940692598345, 27.682447876211665],
              [85.407940692598345, 27.677527976567895],
              [85.405497288010082, 27.677117984930913],
              [85.402239415225736, 27.673838051835062],
              [85.398167074245308, 27.672608076924121],
              [85.396538137853128, 27.670558118739216],
              [85.388393455892256, 27.670968110376197],
              [85.38513558310791, 27.671788093650157],
              [85.381063242127468, 27.668918152191292],
              [85.379434305735302, 27.670148127102234],
              [85.380248773931385, 27.671378102013179],
              [85.37128962377443, 27.670558118739216],
              [85.367217282793987, 27.673018068561102],
              [85.366402814597905, 27.669738135465252],
              [85.363144941813559, 27.668918152191292]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "id": null,
          "F_ID": 106,
          "N_ID": "changunarayan-bhaktapur",
          "NAME": "Changunarayan",
          "LEVEL": "Nagarpalika",
          "DISTRICT": "Bhaktapur"
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [85.523595176442726, 27.693927642047136],
              [85.52196624005056, 27.692697667136194],
              [85.515450494481854, 27.691467692225249],
              [85.50812028071708, 27.692697667136194],
              [85.505676876128817, 27.689007742403362],
              [85.50486240793272, 27.683267859485628],
              [85.500790066952291, 27.675478018382989],
              [85.498346662364028, 27.673428060198084],
              [85.498346662364028, 27.670148127102234],
              [85.495903257775765, 27.66522822745846],
              [85.496717725971848, 27.662768277636573],
              [85.493459853187503, 27.658258369629785],
              [85.487758575814894, 27.655798419807898],
              [85.483686234834465, 27.656618403081858],
              [85.47879942565794, 27.659898336177708],
              [85.47554155287358, 27.657848377992803],
              [85.471469211893151, 27.659488344540726],
              [85.467396870912722, 27.659488344540726],
              [85.466582402716625, 27.66112831108865],
              [85.462510061736197, 27.659488344540726],
              [85.456808784363588, 27.661538302725631],
              [85.455994316167491, 27.663178269273555],
              [85.444591761422274, 27.6644082441845],
              [85.444591761422274, 27.666458202369405],
              [85.447849634206619, 27.66850816055431],
              [85.451107506990965, 27.675478018382989],
              [85.447035166010536, 27.676707993293931],
              [85.448664102402716, 27.682037884574687],
              [85.448664102402716, 27.686957784218457],
              [85.450293038794882, 27.691057700588267],
              [85.440519420441831, 27.688187759129402],
              [85.437261547657485, 27.6795779347528],
              [85.427487929304448, 27.678757951478836],
              [85.419343247343576, 27.677527976567895],
              [85.414456438167051, 27.6795779347528],
              [85.410384097186608, 27.677117984930913],
              [85.407940692598345, 27.677527976567895],
              [85.407940692598345, 27.682447876211665],
              [85.403053883421833, 27.684497834396574],
              [85.401424947029653, 27.698027558416946],
              [85.398167074245308, 27.701717483149778],
              [85.398981542441391, 27.703357449697702],
              [85.404682819813999, 27.705407407882607],
              [85.405497288010082, 27.708277349341476],
              [85.410384097186608, 27.711557282437322],
              [85.414456438167051, 27.711557282437322],
              [85.414456438167051, 27.713197248985246],
              [85.412013033578788, 27.716477182081096],
              [85.413641969970968, 27.717297165355056],
              [85.416899842755313, 27.716067190444114],
              [85.417714310951396, 27.720167106813925],
              [85.422601120127922, 27.719757115176943],
              [85.423415588324005, 27.723447039909775],
              [85.429116865696614, 27.723447039909775],
              [85.430745802088794, 27.725087006457699],
              [85.441333888637928, 27.727956947916567],
              [85.441333888637928, 27.725906989731662],
              [85.445406229618357, 27.724267023183735],
              [85.447849634206619, 27.72549699809468],
              [85.451107506990965, 27.723857031546753],
              [85.453550911579228, 27.72139708172487],
              [85.455179847971408, 27.721807073361848],
              [85.457623252559671, 27.720577098450907],
              [85.459252188951837, 27.719757115176943],
              [85.461695593540099, 27.720577098450907],
              [85.464953466324459, 27.718527140266001],
              [85.467396870912722, 27.720167106813925],
              [85.470654743697068, 27.720167106813925],
              [85.471469211893151, 27.717297165355056],
              [85.477984957461842, 27.716067190444114],
              [85.47879942565794, 27.717297165355056],
              [85.482057298442285, 27.718527140266001],
              [85.489387512207074, 27.718527140266001],
              [85.499161130560111, 27.723037048272793],
              [85.505676876128817, 27.723447039909775],
              [85.517893899070117, 27.727546956279586],
              [85.522780708246643, 27.727956947916567],
              [85.527667517423168, 27.725087006457699],
              [85.52196624005056, 27.71811714862902],
              [85.523595176442726, 27.713607240622228],
              [85.522780708246643, 27.710327307526381],
              [85.523595176442726, 27.70622739115657],
              [85.523595176442726, 27.700487508238833],
              [85.522780708246643, 27.698437550053928],
              [85.523595176442726, 27.693927642047136]
            ]
          ]
        }
      },
      {
        "type": "Feature",
        "properties": {
          "id": null,
          "F_ID": 107,
          "N_ID": "suryabinayak-bhaktapur",
          "NAME": "Suryabinayak",
          "LEVEL": "Nagarpalika",
          "DISTRICT": "Bhaktapur"
        },
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [
              [85.363144941813559, 27.668918152191292],
              [85.366402814597905, 27.669738135465252],
              [85.367217282793987, 27.673018068561102],
              [85.37128962377443, 27.670558118739216],
              [85.380248773931385, 27.671378102013179],
              [85.379434305735302, 27.670148127102234],
              [85.381063242127468, 27.668918152191292],
              [85.38513558310791, 27.671788093650157],
              [85.388393455892256, 27.670968110376197],
              [85.396538137853128, 27.670558118739216],
              [85.398167074245308, 27.672608076924121],
              [85.402239415225736, 27.673838051835062],
              [85.410384097186608, 27.671788093650157],
              [85.420157715539659, 27.666458202369405],
              [85.428302397500531, 27.66522822745846],
              [85.440519420441831, 27.666048210732423],
              [85.443777293226191, 27.663588260910537],
              [85.444591761422274, 27.6644082441845],
              [85.455994316167491, 27.663178269273555],
              [85.456808784363588, 27.661538302725631],
              [85.462510061736197, 27.659488344540726],
              [85.466582402716625, 27.66112831108865],
              [85.467396870912722, 27.659488344540726],
              [85.471469211893151, 27.659488344540726],
              [85.47554155287358, 27.657848377992803],
              [85.47879942565794, 27.659898336177708],
              [85.483686234834465, 27.656618403081858],
              [85.487758575814894, 27.655798419807898],
              [85.493459853187503, 27.658258369629785],
              [85.49264538499142, 27.655798419807898],
              [85.495088789579682, 27.652108495075066],
              [85.486944107618811, 27.647188595431295],
              [85.482057298442285, 27.64185870415054],
              [85.480428362050105, 27.644728645609408],
              [85.47879942565794, 27.644318653972427],
              [85.47879942565794, 27.642268695787521],
              [85.47879942565794, 27.640628729239598],
              [85.474727084677497, 27.634888846321861],
              [85.472283680089234, 27.633658871410919],
              [85.466582402716625, 27.625459038671298],
              [85.462510061736197, 27.624229063760353],
              [85.461695593540099, 27.627918988493185],
              [85.455994316167491, 27.635708829595824],
              [85.449478570598799, 27.628738971767145],
              [85.442148356834011, 27.627099005219222],
              [85.440519420441831, 27.623409080486393],
              [85.438076015853582, 27.62258909721243],
              [85.430745802088794, 27.624639055397335],
              [85.425858992912268, 27.620129147390543],
              [85.420972183735742, 27.619719155753561],
              [85.409569628990525, 27.629148963404127],
              [85.407940692598345, 27.629558955041109],
              [85.406311756206179, 27.632428896499974],
              [85.398981542441391, 27.632838888136956],
              [85.395723669657045, 27.635708829595824],
              [85.393280265068782, 27.641038720876576],
              [85.391651328676602, 27.644728645609408],
              [85.390022392284436, 27.643498670698463],
              [85.386764519500076, 27.648828561979219],
              [85.376990901147039, 27.651288511801106],
              [85.375361964754859, 27.653748461622992],
              [85.373733028362693, 27.653338469986011],
              [85.372104091970513, 27.654568444896952],
              [85.372104091970513, 27.659898336177708],
              [85.367217282793987, 27.659898336177708],
              [85.365588346401822, 27.662358285999595],
              [85.363144941813559, 27.66112831108865],
              [85.365588346401822, 27.664818235821482],
              [85.363144941813559, 27.668918152191292]
            ]
          ]
        }
      },
    ]
  },

  'changunarayan_municipality_data': {
    "type": "FeatureCollection",
    "crs": {
      "type": "name",
      "properties": {
        "name": "urn:ogc:def:crs:OGC:1.3:CRS84"
      }
    },
    "features": [{
      "type": "Feature",
      "properties": {
        "id": null,
        "F_ID": 106,
        "N_ID": "changunarayan-bhaktapur",
        "NAME": "Changunarayan",
        "LEVEL": "Nagarpalika",
        "DISTRICT": "Bhaktapur"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [85.523595176442726, 27.693927642047136],
            [85.52196624005056, 27.692697667136194],
            [85.515450494481854, 27.691467692225249],
            [85.50812028071708, 27.692697667136194],
            [85.505676876128817, 27.689007742403362],
            [85.50486240793272, 27.683267859485628],
            [85.500790066952291, 27.675478018382989],
            [85.498346662364028, 27.673428060198084],
            [85.498346662364028, 27.670148127102234],
            [85.495903257775765, 27.66522822745846],
            [85.496717725971848, 27.662768277636573],
            [85.493459853187503, 27.658258369629785],
            [85.487758575814894, 27.655798419807898],
            [85.483686234834465, 27.656618403081858],
            [85.47879942565794, 27.659898336177708],
            [85.47554155287358, 27.657848377992803],
            [85.471469211893151, 27.659488344540726],
            [85.467396870912722, 27.659488344540726],
            [85.466582402716625, 27.66112831108865],
            [85.462510061736197, 27.659488344540726],
            [85.456808784363588, 27.661538302725631],
            [85.455994316167491, 27.663178269273555],
            [85.444591761422274, 27.6644082441845],
            [85.444591761422274, 27.666458202369405],
            [85.447849634206619, 27.66850816055431],
            [85.451107506990965, 27.675478018382989],
            [85.447035166010536, 27.676707993293931],
            [85.448664102402716, 27.682037884574687],
            [85.448664102402716, 27.686957784218457],
            [85.450293038794882, 27.691057700588267],
            [85.440519420441831, 27.688187759129402],
            [85.437261547657485, 27.6795779347528],
            [85.427487929304448, 27.678757951478836],
            [85.419343247343576, 27.677527976567895],
            [85.414456438167051, 27.6795779347528],
            [85.410384097186608, 27.677117984930913],
            [85.407940692598345, 27.677527976567895],
            [85.407940692598345, 27.682447876211665],
            [85.403053883421833, 27.684497834396574],
            [85.401424947029653, 27.698027558416946],
            [85.398167074245308, 27.701717483149778],
            [85.398981542441391, 27.703357449697702],
            [85.404682819813999, 27.705407407882607],
            [85.405497288010082, 27.708277349341476],
            [85.410384097186608, 27.711557282437322],
            [85.414456438167051, 27.711557282437322],
            [85.414456438167051, 27.713197248985246],
            [85.412013033578788, 27.716477182081096],
            [85.413641969970968, 27.717297165355056],
            [85.416899842755313, 27.716067190444114],
            [85.417714310951396, 27.720167106813925],
            [85.422601120127922, 27.719757115176943],
            [85.423415588324005, 27.723447039909775],
            [85.429116865696614, 27.723447039909775],
            [85.430745802088794, 27.725087006457699],
            [85.441333888637928, 27.727956947916567],
            [85.441333888637928, 27.725906989731662],
            [85.445406229618357, 27.724267023183735],
            [85.447849634206619, 27.72549699809468],
            [85.451107506990965, 27.723857031546753],
            [85.453550911579228, 27.72139708172487],
            [85.455179847971408, 27.721807073361848],
            [85.457623252559671, 27.720577098450907],
            [85.459252188951837, 27.719757115176943],
            [85.461695593540099, 27.720577098450907],
            [85.464953466324459, 27.718527140266001],
            [85.467396870912722, 27.720167106813925],
            [85.470654743697068, 27.720167106813925],
            [85.471469211893151, 27.717297165355056],
            [85.477984957461842, 27.716067190444114],
            [85.47879942565794, 27.717297165355056],
            [85.482057298442285, 27.718527140266001],
            [85.489387512207074, 27.718527140266001],
            [85.499161130560111, 27.723037048272793],
            [85.505676876128817, 27.723447039909775],
            [85.517893899070117, 27.727546956279586],
            [85.522780708246643, 27.727956947916567],
            [85.527667517423168, 27.725087006457699],
            [85.52196624005056, 27.71811714862902],
            [85.523595176442726, 27.713607240622228],
            [85.522780708246643, 27.710327307526381],
            [85.523595176442726, 27.70622739115657],
            [85.523595176442726, 27.700487508238833],
            [85.522780708246643, 27.698437550053928],
            [85.523595176442726, 27.693927642047136]
          ]
        ]
      }
    }, ]
  },

  'bhaktapur_municipality_data': {
    "type": "FeatureCollection",
    "crs": {
      "type": "name",
      "properties": {
        "name": "urn:ogc:def:crs:OGC:1.3:CRS84"
      }
    },
    "features": [{
      "type": "Feature",
      "properties": {
        "id": null,
        "F_ID": 104,
        "N_ID": "bhaktapur-bhaktapur",
        "NAME": "Bhaktapur",
        "LEVEL": "Nagarpalika",
        "DISTRICT": "Bhaktapur"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [85.444591761422274, 27.6644082441845],
            [85.443777293226191, 27.663588260910537],
            [85.440519420441831, 27.666048210732423],
            [85.428302397500531, 27.66522822745846],
            [85.420157715539659, 27.666458202369405],
            [85.410384097186608, 27.671788093650157],
            [85.402239415225736, 27.673838051835062],
            [85.405497288010082, 27.677117984930913],
            [85.407940692598345, 27.677527976567895],
            [85.410384097186608, 27.677117984930913],
            [85.414456438167051, 27.6795779347528],
            [85.419343247343576, 27.677527976567895],
            [85.427487929304448, 27.678757951478836],
            [85.437261547657485, 27.6795779347528],
            [85.440519420441831, 27.688187759129402],
            [85.450293038794882, 27.691057700588267],
            [85.448664102402716, 27.686957784218457],
            [85.448664102402716, 27.682037884574687],
            [85.447035166010536, 27.676707993293931],
            [85.451107506990965, 27.675478018382989],
            [85.447849634206619, 27.66850816055431],
            [85.444591761422274, 27.666458202369405],
            [85.444591761422274, 27.6644082441845]
          ]
        ]
      }
    }, ]
  },

  'madhyapur_thimi_municipality_data': {
    "type": "FeatureCollection",
    "crs": {
      "type": "name",
      "properties": {
        "name": "urn:ogc:def:crs:OGC:1.3:CRS84"
      }
    },
    "features": [{
      "type": "Feature",
      "properties": {
        "id": null,
        "F_ID": 105,
        "N_ID": "madhyapur -thimi-bhaktap",
        "NAME": "Madhyapur Thimi",
        "LEVEL": "Nagarpalika",
        "DISTRICT": "Bhaktapur"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [85.363144941813559, 27.668918152191292],
            [85.35418579165659, 27.667688177280347],
            [85.358258132637033, 27.675888010019968],
            [85.35744366444095, 27.678347959841854],
            [85.359072600833116, 27.682447876211665],
            [85.362330473617462, 27.681627892937705],
            [85.36966068738225, 27.688187759129402],
            [85.372104091970513, 27.689007742403362],
            [85.373733028362693, 27.692287675499212],
            [85.376176432950956, 27.690647708951289],
            [85.377805369343122, 27.690647708951289],
            [85.377805369343122, 27.694337633684118],
            [85.380248773931385, 27.693107658773176],
            [85.38350664671573, 27.693927642047136],
            [85.386764519500076, 27.692287675499212],
            [85.386764519500076, 27.695977600232041],
            [85.389207924088339, 27.696797583506005],
            [85.391651328676602, 27.697207575142986],
            [85.390836860480519, 27.700897499875815],
            [85.391651328676602, 27.702127474786757],
            [85.394909201460962, 27.702537466423738],
            [85.397352606049211, 27.700897499875815],
            [85.398167074245308, 27.701717483149778],
            [85.401424947029653, 27.698027558416946],
            [85.403053883421833, 27.684497834396574],
            [85.407940692598345, 27.682447876211665],
            [85.407940692598345, 27.677527976567895],
            [85.405497288010082, 27.677117984930913],
            [85.402239415225736, 27.673838051835062],
            [85.398167074245308, 27.672608076924121],
            [85.396538137853128, 27.670558118739216],
            [85.388393455892256, 27.670968110376197],
            [85.38513558310791, 27.671788093650157],
            [85.381063242127468, 27.668918152191292],
            [85.379434305735302, 27.670148127102234],
            [85.380248773931385, 27.671378102013179],
            [85.37128962377443, 27.670558118739216],
            [85.367217282793987, 27.673018068561102],
            [85.366402814597905, 27.669738135465252],
            [85.363144941813559, 27.668918152191292]
          ]
        ]
      }
    }, ]
  },

  'suryabinayak_municipality_data': {
    "type": "FeatureCollection",
    "crs": {
      "type": "name",
      "properties": {
        "name": "urn:ogc:def:crs:OGC:1.3:CRS84"
      }
    },
    "features": [{
      "type": "Feature",
      "properties": {
        "id": null,
        "F_ID": 107,
        "N_ID": "suryabinayak-bhaktapur",
        "NAME": "Suryabinayak",
        "LEVEL": "Nagarpalika",
        "DISTRICT": "Bhaktapur"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [85.363144941813559, 27.668918152191292],
            [85.366402814597905, 27.669738135465252],
            [85.367217282793987, 27.673018068561102],
            [85.37128962377443, 27.670558118739216],
            [85.380248773931385, 27.671378102013179],
            [85.379434305735302, 27.670148127102234],
            [85.381063242127468, 27.668918152191292],
            [85.38513558310791, 27.671788093650157],
            [85.388393455892256, 27.670968110376197],
            [85.396538137853128, 27.670558118739216],
            [85.398167074245308, 27.672608076924121],
            [85.402239415225736, 27.673838051835062],
            [85.410384097186608, 27.671788093650157],
            [85.420157715539659, 27.666458202369405],
            [85.428302397500531, 27.66522822745846],
            [85.440519420441831, 27.666048210732423],
            [85.443777293226191, 27.663588260910537],
            [85.444591761422274, 27.6644082441845],
            [85.455994316167491, 27.663178269273555],
            [85.456808784363588, 27.661538302725631],
            [85.462510061736197, 27.659488344540726],
            [85.466582402716625, 27.66112831108865],
            [85.467396870912722, 27.659488344540726],
            [85.471469211893151, 27.659488344540726],
            [85.47554155287358, 27.657848377992803],
            [85.47879942565794, 27.659898336177708],
            [85.483686234834465, 27.656618403081858],
            [85.487758575814894, 27.655798419807898],
            [85.493459853187503, 27.658258369629785],
            [85.49264538499142, 27.655798419807898],
            [85.495088789579682, 27.652108495075066],
            [85.486944107618811, 27.647188595431295],
            [85.482057298442285, 27.64185870415054],
            [85.480428362050105, 27.644728645609408],
            [85.47879942565794, 27.644318653972427],
            [85.47879942565794, 27.642268695787521],
            [85.47879942565794, 27.640628729239598],
            [85.474727084677497, 27.634888846321861],
            [85.472283680089234, 27.633658871410919],
            [85.466582402716625, 27.625459038671298],
            [85.462510061736197, 27.624229063760353],
            [85.461695593540099, 27.627918988493185],
            [85.455994316167491, 27.635708829595824],
            [85.449478570598799, 27.628738971767145],
            [85.442148356834011, 27.627099005219222],
            [85.440519420441831, 27.623409080486393],
            [85.438076015853582, 27.62258909721243],
            [85.430745802088794, 27.624639055397335],
            [85.425858992912268, 27.620129147390543],
            [85.420972183735742, 27.619719155753561],
            [85.409569628990525, 27.629148963404127],
            [85.407940692598345, 27.629558955041109],
            [85.406311756206179, 27.632428896499974],
            [85.398981542441391, 27.632838888136956],
            [85.395723669657045, 27.635708829595824],
            [85.393280265068782, 27.641038720876576],
            [85.391651328676602, 27.644728645609408],
            [85.390022392284436, 27.643498670698463],
            [85.386764519500076, 27.648828561979219],
            [85.376990901147039, 27.651288511801106],
            [85.375361964754859, 27.653748461622992],
            [85.373733028362693, 27.653338469986011],
            [85.372104091970513, 27.654568444896952],
            [85.372104091970513, 27.659898336177708],
            [85.367217282793987, 27.659898336177708],
            [85.365588346401822, 27.662358285999595],
            [85.363144941813559, 27.66112831108865],
            [85.365588346401822, 27.664818235821482],
            [85.363144941813559, 27.668918152191292]
          ]
        ]
      }
    }, ]
  }

}
